import axios from "axios";
import env from "@/configs/env/config";
import store from "../store/index";
import router from "../router/index";

axios.defaults.baseURL = env.API_URL;
axios.defaults.headers.common["Authorization"] = "";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";

// axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.interceptors.request.use(
  function (config) {
    config.headers["x-api-key"] = env.X_API_KEY;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(null, function (error) {
  let appDebug = 0;
  if (!appDebug) {
    let arrayErrorCode = [400, 401, 403, 404, 409, 422, 500, 502, 503];
    if (arrayErrorCode.indexOf(error.response.status) !== -1) {
      // console.log("status ", error.response.status);
      // console.log("router", router);
      // for (let i in error) {
      //   console.log("err", i, error[i]);
      // }

      //ngoai le
      let exceptionArr = [
        {
          url: "changeshopmode",
          code: 500,
        },
        {
          url: "updateprintcontens",
          code: 409,
        },
      ];
      let isException = false;
      let arrayExcludePage = ["a095"];
      let isExcludePage =
        arrayExcludePage.indexOf(router.currentRoute.name) !== -1;
      if (isExcludePage) {
        isException = true;
      }
      for (let indexEx = 0; indexEx < exceptionArr.length; indexEx++) {
        const ex = exceptionArr[indexEx];
        if (
          error.config.url.indexOf(ex.url) !== -1 &&
          error.response.status == ex.code
        ) {
          isException = true;
          break;
        }
      }

      if (!isException) {
        let status = error.response.status;
        let message = "front_end.common.error_page.error" + status;
        store.dispatch("errorStore/redirectErrorPage", {
          status: status,
          message: message,
        });
      }

      return Promise.reject(error);
    }
  }

  if (!error.response) {
    if (error.message == "Network Error") {
      // console.log("errror net work", JSON.stringify(error), error.response);

      let status = "Network Error";
      let message = "front_end.common.error_page.error_network";
      store.dispatch("errorStore/redirectErrorPage", {
        status: status,
        message: message,
      });
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
});

export default {
  request(method, url, params, data, headers = {}) {
    // const sessionId = store.state.userStore.sessionId;
    // if (sessionId) this.setSessionIdHeader(sessionId);

    return axios.request({
      url,
      params,
      data,
      method: method.toLowerCase(),
      headers,
    });
  },

  get(url, params) {
    return this.request("get", url, params, {});
  },

  post(url, data, headers = {}) {
    return this.request("post", url, {}, data, headers);
  },

  put(url, data) {
    return this.request("put", url, {}, data);
  },

  delete(url, data = {}) {
    return this.request("delete", url, {}, data);
  },

  setSessionIdHeader(sessionId) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + sessionId;
  },

  removeSessionIdHeader() {
    axios.defaults.headers.common["Authorization"] = "";
  },
};
